import React, { FC } from 'react';
import { SvgIcon } from '@mui/material';

import type { IconAssetProps } from '../../types/components/icon_types';

export const Chair: FC<IconAssetProps> = ({ size, sx }: IconAssetProps) => {
  const style = size ? { width: `${size}px` } : {};

  return (
    <SvgIcon sx={{ ...style, ...sx }}>
      <path
        d="M9 12.5H18.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 13L16.5 19.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.5 13L9 19.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 12.5L6 3.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
